<template>
  <div class="getCode loginCom">
    <div class="getCodeMain loginMmain">
      <div class="getCodeMain_title">输入验证码</div>
      <div class="getCodeMain_describe">
        短信验证码已发送至{{ userPhone ? userPhone : '您的手机' }}
      </div>
    </div>
    <CodeInput
      :clearIpt="isFlag"
      :loginType="loginWay"
      @loginSuccess="loginSuccess"
    ></CodeInput>

    <div class="resetGetCode">
      <div
        :class="{ getCodeText: residueTime > '59' ? false : true, activeClass: isFlag }"
        @click="getCodeBtn()"
      >
        <span>{{ getCodeTime }}</span>
        <span :class="{ idNone: residueTime <= '59' ? false : true }">（{{ this.residueTime }}）</span>
      </div>
    </div>
  </div>
</template>

<script>
import '@/assets/css/loginCommon.css';
import CodeInput from './codeInput2.vue';
// eslint-disable-next-line import/order
import { Toast } from 'vant';

export default {
  components: {
    CodeInput,
  },
  data() {
    return {
      getCodeTime: '重新获取',
      isFlag: true,
      residueTime: 59,
      code: [],
      timer: null,
      requestCode: true,
    };
  },

  methods: {
    loginSuccess(user){
      this.$emit('loginCallBack',user)
    },
    // getCodeReturn() {
    //   if (this.loginWay === 'login') {
    //     this.$router.replace({
    //       path: '/registrationLogin',
    //       query: JSON.parse(this.urlParams),
    //       params: JSON.parse(this.pagesParams),
    //     });
    //   } else if (this.loginWay === 'forgetPassword') {
    //     this.$router.replace({
    //       path: '/retrievePassword',
    //       query: JSON.parse(this.urlParams),
    //       params: JSON.parse(this.pagesParams),
    //     });
    //   }
    // },
    // 倒计时
    getCodeBtn() {
      // if (!this.isFlag) return;
      if (!this.requestCode) return;

      this.getCode();
    },
    getCode() {
      this.isFlag = true;
      this.requestCode = true;
      this.residueTime = 59;
      clearInterval(this.timer);
      this.timer = null;
      if (this.loginWay === 'login') {
        this.$router.replace({
          path: '/registrationLogin',
          query: JSON.parse(this.urlParams),
          params: JSON.parse(this.pagesParams),
        });
      } else if (this.loginWay === 'forgetPassword') {
        this.$router.replace({
          path: '/retrievePassword',
          query: JSON.parse(this.urlParams),
          params: JSON.parse(this.pagesParams),
        });
      }
    },
    countDown() {
      this.timer = setInterval(() => {
        this.residueTime -= 1;
        if (this.residueTime <= 0) {
          this.isFlag = true;
          this.requestCode = true;
          this.residueTime = 59;
          clearInterval(this.timer);
          this.timer = null;
        }
      }, 1000);
    },
    Toast(msg) {
      Toast({
        message: msg,
        duration: 3 * 1000,
        position: 'top',
      });
    },
  },
  created() {
    const { userPhone } = this.$store.state;
    const { loginWay, fromPath } = this.$route.params;

    this.urlParams = window.localStorage.getItem('pagesQuery');
    this.pagesParams = window.localStorage.getItem('pagesParams');
    this.userPhone = userPhone;
    this.loginWay = loginWay
      || JSON.parse(this.pagesParams)?.loginWay
      || JSON.parse(this.pagesParams)?.type
      || 'login';
    if (fromPath) {
      this.isFlag = true;
      this.requestCode = true;
      this.residueTime = 59;
      clearInterval(this.timer);
      this.timer = null;
    } else {
      if (this.loginWay === 'forgetPassword' || this.loginWay === 'login' || this.pagesParams) {
        this.isFlag = false;
        this.requestCode = false;
        this.countDown();
        return;
      }

      this.getCodeBtn();
    }
  },
  mounted() {
    document.getElementsByClassName('app')[0].setAttribute('style', 'background-color:#fff');
  },
  beforeDestroy() {
    document.getElementsByClassName('app')[0].removeAttribute('style');
    clearInterval(this.timer);
    this.timer = null;
  },

  beforeCreate() {
  },
};
</script>
<style lang="scss" scoped>
.getCode {
  .getCodeMain {
    .getCodeMain_title {
      padding-top: 89px;
      color: #333;
      font-weight: 500;
      font-size: 51px;
      line-height: 72px;
    }

    .getCodeMain_describe {
      margin: 20px 0 94px 0;
      color: #787878;
      font-weight: 400;
      font-size: 29px;
      line-height: 40px;
    }
  }

  .resetGetCode {
    position: relative;
    width: 100%;
    height: 100px;
    .getCodeText {
      position: absolute;
      top: 34px;
      right: 0.72rem;
      width: 214px;
      height: 54px;
      color: #fff;
      font-size: 25px;
      line-height: 54px;
      text-align: center;
      background-color: #a5a5a5;
      border-radius: 0.07rem;
    }
    .activeClass {
      position: absolute;
      top: 34px;
      right: 0.72rem;
      width: 141px;
      height: 54px;
      color: #fff;
      font-size: 25px;
      line-height: 54px;
      text-align: center;
      background-color: #ff6c02;
      border-radius: 0.07rem;
    }
    .idNone {
      display: none;
    }
  }
}
</style>
